/* global axios */
import ApiClient from '../ApiClient';

class CaptainAssistant extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
      },
    });
  }

  playground({ assistantId, messageContent, messageHistory }) {
    return axios.post(`${this.url}/${assistantId}/playground`, {
      message_content: messageContent,
      message_history: messageHistory,
    });
  }

  transcribeAudio({ assistantId, audioFile }) {
    console.log('[CAPTAIN][API][DEBUG] transcribeAudio called');
    console.log('[CAPTAIN][API][DEBUG] URL:', `${this.url}/${assistantId}/transcribe_audio`);
    console.log('[CAPTAIN][API][DEBUG] Assistant ID:', assistantId);
    console.log('[CAPTAIN][API][DEBUG] Audio file:', audioFile);
    
    return axios.post(
      `${this.url}/${assistantId}/transcribe_audio`,
      audioFile,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    ).then(response => {
      console.log('[CAPTAIN][API][DEBUG] transcribeAudio response:', response);
      return response;
    }).catch(error => {
      console.error('[CAPTAIN][API][ERROR] transcribeAudio error:', error);
      console.error('[CAPTAIN][API][ERROR] Error response data:', error.response?.data);
      throw error;
    });
  }
}

export default new CaptainAssistant();
